import { apiFetch } from "./api";

export const SUBSCRIPTIONS_DISABLED_MESSAGE =
  'Subscription changes are not available yet. We’ve noted your interest and will notify you when this becomes available.';

export const fetchSubscriptionConfig = async (fetchOptions = {}) => {
  const resp = await apiFetch("/api/subscription/config/", {
    headers: { "Content-Type": "application/json", ...(fetchOptions.headers || {}) },
    ...fetchOptions,
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.error || "Failed to load subscription configuration.");
  }
  return data || {};
};

/**
 * IMPORTANT product rule: if config is not reachable, default is allowed=true.
 */
export const getNewSubscriptionsAllowedSafe = async () => {
  try {
    const data = await fetchSubscriptionConfig();
    const v = data?.new_subscriptions_allowed;
    if (typeof v === "boolean") return v;
    // If backend returns an unexpected shape, fail open.
    return true;
  } catch {
    return true;
  }
};

